// extracted by mini-css-extract-plugin
export default {"imageWrapper":"wH-z","twoColumnImage":"xH-z"};